import React, { PureComponent } from "react";

import {
	Panel
} from "react-bootstrap";

import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import autoBind from "react-autobind";
import _ from "lodash";

class NavigationPanel extends PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);

		this.state = {
			expanded: false
		};
	}

	handleToggleExpanded() {
		this.setState({
			expanded: !this.state.expanded
		});
	}


	render() {

		let { heading, body } = this.props;

		let headingStyle = this.props.headingStyle || {};
		headingStyle = _.assign(headingStyle, {cursor: "pointer"});
		
		let navigationPanel = 
			<Panel bsStyle="default" className="navigation-drawer-panel" expanded={this.state.expanded} onToggle={this.handleToggleExpanded}>
				<Panel.Heading className="navigation-panel-heading" style={headingStyle} onClick={this.handleToggleExpanded}>
					{heading}
					<FontAwesomeIcon icon={this.state.expanded ? "chevron-up" : "chevron-right"} />
				</Panel.Heading>
				<Panel.Collapse>
					<Panel.Body style={this.props.bodyStyle}>
						{body}
					</Panel.Body>
				</Panel.Collapse>
			</Panel>;


		return navigationPanel;
	}
}



export default NavigationPanel;